import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingComponent } from '../../../generic/loading/loading.component';
import { extractTokensFromUrl, validateTokenAndDecode } from '../../../../utilities/token/validateToken';
import { environment } from '../../../../../environments/environment';
import { Store } from '@ngrx/store';
import { loginSuccess, logout } from '../../../../store/user/user.actions';


@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [LoadingComponent],
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css']
})
export class AuthCallbackComponent implements OnInit {

  constructor(private router: Router,private store: Store) {}

  ngOnInit(): void {
    try {
      const { idToken, accessToken } = extractTokensFromUrl();
      if (accessToken && idToken) {
        const decodedIdToken = validateTokenAndDecode(idToken);

        if (decodedIdToken) {
          const email = decodedIdToken.email;
          const groups = decodedIdToken['cognito:groups'] || [];
          const name = decodedIdToken.given_name;
          const familyName = decodedIdToken.family_name;
          const id = decodedIdToken['custom:NameID'];
          if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            localStorage.setItem('userToken', JSON.stringify({
              email, groups, id, name, familyName, accessToken
            }));
          }
          this.store.dispatch(loginSuccess({ userInfo: {
            email, groups, id, name, familyName, accessToken
          }}));
          const targetRoute = groups.includes('AdminUsers') ? '/admin/dashboard' : '/technician/home';

          this.navigateTo(targetRoute);
        } else {
          this.store.dispatch(logout());
          if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            localStorage.removeItem('userToken');
          }
          this.navigateTo('/login');
        }
      } else if (environment.isDevMode) {
        this.navigateTo('/technician/home');
      } else {
        this.navigateTo('/login');
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
          localStorage.removeItem('userToken');
        }
      }
    } catch (error) {
      console.error("Error extracting tokens from URL:", error);
      if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
        localStorage.removeItem('userToken');
      }
      this.navigateTo('/login');
    }
  }

  private navigateTo(route: string): void {
    this.router.navigate([route]);
  }
}